import { render, staticRenderFns } from "./Curve2d.vue?vue&type=template&id=51ff0b55&scoped=true&"
import script from "./Curve2d.vue?vue&type=script&lang=js&"
export * from "./Curve2d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ff0b55",
  null
  
)

export default component.exports